import React, { Fragment, useContext } from "react";
import { StepRenderProps } from "../../../interfaces/FlowInterfaces";
import { Button, createStyles, makeStyles, Theme } from "@material-ui/core";
import { observer } from "mobx-react";
import { OrganizationProfileLimitStepValues } from "../../_interfaces/IOrganizationSignUpStepTypeValues";
import { IOrganizationSignUpFlowValues } from "../../_interfaces/IOrganizationSignUpFlowValues";
import { Alert, AlertTitle } from "@material-ui/lab";
import { LogoutRequiredForm } from "../../../../authentication/components/LogoutRequiredForm";
import { useOrganizationProfileLimitController } from "../../hooks/useOrganizationProfileLimitController";
import { OrganizationSignUpHeader } from "../OrganizationSignUpHeader";
import { RootContext } from "../../../../../stores";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        alert: {
            textAlign: 'left',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginBottom: theme.spacing(3),
            maxWidth: 900
        },
        button: {
            marginTop: theme.spacing(1),
            display: 'block'
        }
    })
);

export const OrganizationProfileLimitStep: React.FC<
    StepRenderProps<OrganizationProfileLimitStepValues, IOrganizationSignUpFlowValues>
> = observer(({
    values,
    update,
    submit,
    canSubmit,
    validation,
    allValues
}) => {

    /********* React hooks *********/

    const classes = useStyles();
    const controller = useOrganizationProfileLimitController(values, allValues, update, submit);
    const rootStore = useContext(RootContext);

    /********* Event handlers *********/

    const onContactUsClicked = () => {
        rootStore.navigationStore.appwideDialogStates.contactUsDialog.setOpen(true);
        rootStore.helpStore.setHelpMessageOverrides({
            subject: 'Organization Admin Profiles Limit Increase Request',
        });
    };

    /********* Render *********/

    return (
        <Fragment>
            <OrganizationSignUpHeader />
            <Alert severity="error" className={classes.alert}>
                <AlertTitle>Maximum Organization Admin Profiles Reached</AlertTitle>
                You've reached the maximum number of organization admin profiles allowed for a single user account. If you would like to proceed by creating a new user account, please logout below. If you would like to increase your limit, please contact us for support.
                <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={onContactUsClicked}
                >
                    Contact Us
                </Button>
            </Alert>
            <LogoutRequiredForm
                values={controller.values}
                onChange={(patch) => {
                    controller.onChange(patch);
                    update(patch); // sync with Flow
                }}
                onSubmit={controller.onSubmit}
                isSubmitting={controller.isSubmitting}
                error={controller.error}
                fieldErrors={controller.fieldErrors}
            />
        </Fragment>
    );
});